// 客户审核
const AuditCustomer = () => import('@/pages/audit/custom-audit.vue');
// 客户审核-查看/审核
const AuditCustomerDetail = () => import('@/pages/audit/custom-audit-detail.vue');

const arr = [
  // 客户审核
  {
    path: '/audit/cusAudit',
    name: 'auditCustomer',
    component: AuditCustomer,
    meta: {
      auth: false,
    },
  },
  // 客户审核-查看/审核
  {
    path: '/audit/custom/detail',
    name: 'auditCustomerDetail',
    component: AuditCustomerDetail,
    meta: {
      auth: false,
    },
  },
];

export default arr;
